"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Queue = void 0;
class Queue {
    constructor() {
        this._queue = [];
    }
    get isEmpty() {
        return this._queue.length === 0;
    }
    enqueue(item) {
        this._queue.push(item);
    }
    dequeue() {
        return this._queue.shift();
    }
    peek() {
        if (this._queue.length !== 0) {
            return this._queue[0];
        }
    }
    clear() {
        this._queue = [];
    }
    static fromArray(arr) {
        const queue = new Queue();
        for (const item of arr) {
            queue.enqueue(item);
        }
        return queue;
    }
}
exports.Queue = Queue;
